import React, { useLayoutEffect, useState } from 'react';
import { Box } from '@mui/material';

import { useStyles } from './ArchivedBugReports.styles';
import theme from '../../../styles/theme';
import Search from '../../../components/reusable/search/Search';
import { useGetBugReportArchived } from '../../../services/redux/api/bugReportApi';
import { IBugReport } from '../../../types/interfaces/bug-report';
import { Paths } from '../../../shared/paths';
import { useLocation, useNavigate } from 'react-router-dom';
import BugReportItem from '../active-bug-reports/bug-report-item/BugReportItem';

export default function ArchivedBugReports() {
  const [filter, setFilter] = useState('');
  const [reports, setReports] = useState<IBugReport[]>([]);
  const { classes } = useStyles(theme);
  const { data: reportData } = useGetBugReportArchived();
  const navigate = useNavigate();
  const location = useLocation();

  useLayoutEffect(() => {
    if (reportData) {
      setReports(
        reportData.filter((r) =>
          r.title.toLowerCase().includes(filter.toLowerCase()),
        ),
      );
    }
  }, [reportData, filter]);

  return (
    <Box>
      <Search
        fullWidth
        value={filter}
        onChange={setFilter}
        className={classes.bugReportsListSearch}
      />
      <Box className={classes.bugReportsList}>
        {reports.map((report) => (
          <BugReportItem
            report={report}
            onClick={() => {
              navigate(
                Paths.moderatorDashboard.bugReport(report.id, true, 'archived'),
                {
                  state: { from: location.pathname },
                },
              );
            }}
            key={report.id}
          />
        ))}
      </Box>
    </Box>
  );
}
